import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable Button Component
 * Supports primary, secondary, and outline variants with loading states
 * Based on Bootstrap 5 button styles with ADN theming
 */
@Component({
  selector: 'app-form-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss']
})
export class FormButtonComponent {
  @Input() label: string = '';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: 'primary' | 'secondary' | 'outline' | 'danger' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() icon: string = ''; // Bootstrap icon class (e.g., 'bi-check')
  @Input() fullWidth: boolean = false;

  @Output() buttonClick = new EventEmitter<void>();

  /**
   * Get button classes based on variant and size
   */
  get buttonClasses(): string {
    const classes = ['btn'];

    // Variant classes
    switch (this.variant) {
      case 'primary':
        classes.push('btn-primary');
        break;
      case 'secondary':
        classes.push('btn-secondary');
        break;
      case 'outline':
        classes.push('btn-outline-primary');
        break;
      case 'danger':
        classes.push('btn-danger');
        break;
    }

    // Size classes
    if (this.size === 'sm') {
      classes.push('btn-sm');
    } else if (this.size === 'lg') {
      classes.push('btn-lg');
    }

    // Full width
    if (this.fullWidth) {
      classes.push('w-100');
    }

    return classes.join(' ');
  }

  /**
   * Handle button click
   */
  onClick(): void {
    if (!this.disabled && !this.loading) {
      this.buttonClick.emit();
    }
  }
}
